/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import {Type} from "@qwoach/class-transformer-wrapper"
import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import ContactInfo from "@shared/Profile/ContactInfo";
import {formTriggerValidator} from "@/utils/helpers";

export default class FormElementContactInfo extends BaseFormElement {

	@Type(() => ContactInfo)
	answerOptions: ContactInfo[] = []
	allowAddingOptions: boolean = true
	addRelationship: boolean = true

	constructor(title, isRequired) {
		super(FormElementType.CONTACT_INFO, title, isRequired);
	}

	resetElement(){
		super.resetElement()
		this.answerOptions = [new ContactInfo()]
		this.otherAnswer = null
		this.showOtherOption = false
		this.showScoring = false
		this.enableScoring = false
	}

	getAnswer(){
		return this.answerOptions
	}

	setAnswer(answer){
		if(Array.isArray(answer) && answer.length > 0){
			this.answerOptions = answer
		}
	}



	getValidateRules(){
		return formTriggerValidator(async (value) => {
			let error

			for(let info of this.answerOptions){
				let hasFullName = !!info.fullName
				let hasInfo = !!info.contactDetails
				let hasRelationship = !!info.relationship

				let filledAtLeastOne = hasRelationship || hasInfo || hasFullName
				let notFilledAll = !hasFullName || !hasInfo || !(!this.addRelationship || hasRelationship)

				if((this.isRequired || filledAtLeastOne) && notFilledAll){
					error = "Please fill in all the fields"
					break;
				}
			}
			return error
		})
	}
}
